module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_7042.6dddc771.png";